






import { Component, Prop, Vue } from 'vue-property-decorator'

interface SvgClassName {
    type: string
    default: string
}

interface SvgIconName {
    type: string
    required: boolean
}

@Component
export default class SvgIcon extends Vue {
    name = 'SvgIcon'

    @Prop({ type: String, required: true }) private iconName?: SvgIconName

    @Prop({ type: String, default: '' }) private className!: SvgClassName

    get iconClassName() {
        return `#icon-${this.iconName}`
    }

    get svgClass() {
        if (this.className) {
            return 'svg-icon ' + this.className
        } else {
            return 'svg-icon normal'
        }
    }
}
